module.exports = __webpack_public_path__ + "img/image3-1.0eda7d37.png";